import React from "react";
import Aside from "./Aside";
import Main from "./Main.js";

export default function Intro() {
  return (
    <div className="container">
      <Aside />
      <Main />
    </div>
  );
}
